import { render, staticRenderFns } from "./OutpatientCare.vue?vue&type=template&id=69a0401e&scoped=true&"
import script from "./OutpatientCare.vue?vue&type=script&lang=js&"
export * from "./OutpatientCare.vue?vue&type=script&lang=js&"
import style0 from "./OutpatientCare.vue?vue&type=style&index=0&id=69a0401e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a0401e",
  null
  
)

export default component.exports